import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogout = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#999"
        d="M4.5 17q-.618 0-1.06-.44A1.45 1.45 0 0 1 3 15.5v-11q0-.618.44-1.06Q3.883 3 4.5 3h4.75q.319 0 .534.214a.72.72 0 0 1 .216.532q0 .316-.216.535a.72.72 0 0 1-.534.219H4.5v11h4.75q.319 0 .534.214a.72.72 0 0 1 .216.532q0 .316-.216.535A.72.72 0 0 1 9.25 17zm9.625-6.25H8.749a.73.73 0 0 1-.534-.214.72.72 0 0 1-.215-.532q0-.316.215-.535a.72.72 0 0 1 .534-.219h5.376l-1.167-1.167a.73.73 0 0 1 0-1.064.73.73 0 0 1 1.063.002l2.458 2.458q.23.222.23.517a.72.72 0 0 1-.23.525l-2.458 2.458a.68.68 0 0 1-.521.219.8.8 0 0 1-.53-.24.745.745 0 0 1 .01-1.062z"
      />
    </g>
  </svg>
);
export default SvgLogout;
